import api from "./api.config";
const list = (params) => {
    
    return api
        .get(`/api/admin/invoices`, {
            params
        })
        .then((response) => {
            return response.data;
        });
}
const download = (id) => {
    
    return api
        .get(`/api/admin/invoices/download/${id}`, {
            responseType: 'blob'
        })
        .then((response) => {
            return response.data;
        });
}
const InvoicesService = {
    list,
    download
};

export default InvoicesService;